var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.2 63.2c-2.8-3-8.4-4.7-16.4-4.7-4.3 0-9.2.4-14.6 1.4-3-3-6.1-6.5-9-10.6-2.1-2.9-3.9-5.9-5.5-8.9 3.2-9.9 4.7-17.9 4.7-23.7 0-6.5-2.3-13.3-9.1-13.3-2.1 0-4.1 1.3-5.2 3.1-3 5.5-1.7 17.5 3.6 29.3-2 5.9-4 11.6-6.6 17.9-2.2 5.3-4.8 10.9-7.5 15.9-15.2 6.2-25 13.4-25.9 19-.4 2.1.3 4.1 1.8 5.6.5.4 2.5 2.1 5.8 2.1 10.1 0 20.7-16.6 26.1-26.7 4.1-1.4 8.3-2.7 12.4-3.9 4.5-1.3 9.1-2.3 13.2-3C73.6 72.4 83 74 87.7 74c5.8 0 7.9-2.4 8.6-4.4 1.1-2.5.3-5.3-1-6.8l-.1.4zm-5.4 4.1c-.4 2.1-2.5 3.5-5.4 3.5-.8 0-1.5-.1-2.3-.3-5.3-1.3-10.2-4-15.2-8.2 4.9-.8 9-1 11.6-1 2.9 0 5.4.1 7 .6 1.9.4 4.9 1.7 4.3 5.4zm-29.3-6.6c-3.6.7-7.4 1.6-11.4 2.7-3.2.9-6.5 1.8-9.8 3 1.8-3.5 3.3-6.9 4.7-10.1 1.7-4 3-8 4.4-11.8 1.4 2.4 2.9 4.8 4.4 6.9 2.5 3.3 5.1 6.5 7.7 9.3zM42.4 8.2c.6-1.1 1.7-1.7 2.6-1.7 2.9 0 3.4 3.4 3.4 6.1 0 4.5-1.4 11.4-3.7 19.3-4-11-4.3-20.1-2.3-23.7zM27.3 73.9c-7 11.8-13.8 19.2-17.9 19.2-.8 0-1.5-.3-2.1-.7-.8-.8-1.2-1.8-1-3 .8-4.2 8.7-10.1 21-15.5z",
    fill: "#eb1d25",
    stroke: "#eb1d25",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.0dac6e348fbe588c00407d0b2c021f07.svg";
export { ForwardRef as ReactComponent };